    import React from 'react';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';

const DeleteConfirmationModal = ({ show, onHide, onConfirm, itemName, submitting }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title className="text-danger">
        <FaTrash className="me-2" /> Confirm Deletion
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>Are you sure you want to delete: <strong>{itemName}</strong>?</p>
      <Alert variant="danger">This action is permanent and cannot be undone.</Alert>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide} disabled={submitting}>
        Cancel
      </Button>
      <Button variant="danger" onClick={onConfirm} disabled={submitting}>
        {submitting ? (
          <>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            {' '}Deleting...
          </>
        ) : (
          'Delete'
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DeleteConfirmationModal;